<template>
  <b-navbar toggleable="lg" type="dark" class="sticky-top">
<!--    <b-navbar-brand-->
<!--      ><router-link to="prenota"> <img alt="Logo" :width="40" src="../../assets/logo_pic.png" /></router-link-->
<!--    ></b-navbar-brand>-->

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item title="Prenota per te e i tuoi contatti">
          <router-link :to="{name: 'DisponibilitaAttivita'}"><i class="fas fa-laptop-medical"></i> Prenotazione</router-link>
        </b-nav-item>

        <b-nav-item title="Visualizza gli appuntamenti dell'agenda"><router-link to="agenda"><i class="fas fa-user"></i> Area Riservata</router-link></b-nav-item>

      </b-navbar-nav>
      <!-- Right aligned nav items -->
<!--      <b-navbar-nav class="ml-auto">-->
<!--        <b-nav-item-dropdown right>-->
<!--          &lt;!&ndash; Using 'button-content' slot &ndash;&gt;-->
<!--          <template #button-content>-->
<!--            <i class="fas fa-user"></i>-->
<!--          </template>-->
<!--          <b-dropdown-item-->
<!--            ><router-link to="profilo"><i class="fas fa-user"></i> Account Personale</router-link></b-dropdown-item-->
<!--          >-->
<!--          &lt;!&ndash; <b-dropdown-item href="#"><i class="fas fa-lock"></i> Modifica Password</b-dropdown-item> &ndash;&gt;-->
<!--          <b-dropdown-item href="#" @click="onRichiestaDati"><i class="fas fa-database"></i> Richiesta Dati</b-dropdown-item>-->
<!--          <b-dropdown-divider></b-dropdown-divider>-->
<!--          <b-dropdown-item :href="linkTerminiServizio" target="_blank"><i class="fa fa-certificate"></i> Termini di Serivizio</b-dropdown-item>-->
<!--          <b-dropdown-item-->
<!--            ><router-link to="contattaci"><i class="fas fa-at"></i> Contattaci</router-link></b-dropdown-item-->
<!--          >-->
<!--          <b-dropdown-divider></b-dropdown-divider>-->
<!--          <b-dropdown-item @click="onLogOut"><i class="fas fa-power-off"></i> Log out</b-dropdown-item>-->
<!--        </b-nav-item-dropdown>-->
<!--      </b-navbar-nav>-->
    </b-collapse>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#00388C" loader="dots" :height="120" :width="120"></loading>
  </b-navbar>
</template>
<script>
import Loading from "vue-loading-overlay";
export default {
  components: { Loading },
  data() {
    return {
      linkTerminiServizio: "resources/terminiServizio/cittadini.pdf",
      pathResourceRichiesta: "/api/v2.0/appecupt/auth/scaricaAnagrafica",
      tokenLogin: null,
      token: null,
      isLoading: false,
      isAdmin: false
    };
  }
};
</script>
